import React, { useState } from "react";
import { Header, Text } from "@centrate-io/barn";

function SeniorCredit(props) {
    const loan = props?.loan;
    console.log(loan);
    
    return (
        <div className="crumbs" style={{padding: 32}}>
        <Header type="display" size="5">
            Senior & Credit
        </Header>
        </div> 
    );
  }
  
  export default SeniorCredit;